module.exports = "/images/intro-bg.png";